// سقف سوخت/روغن فروشندگان
import React, { useState, useEffect } from 'react';
import ListPage, { ui } from '../../components/ListPage';
import { usePagedList, CountBadge } from '../../components/paging';
import { ExcelButton } from '../../components/excel';
import { useFormButtons } from '../../utils/vbPerms';
import { API, qs, Grid, Field, TextIn, DateIn, Lookup, Modal, DeleteDialog, MsgDialog, excelCols } from './carsShared';

const BUTTONS = ['BTNNEW', 'BTNEDIT', 'BTNDELETE', 'BTNOK', 'BTNCANCEL'];
const FUELS = ['بنزین', 'گازوئیل', 'گاز', 'روغن'];
const blank = () => ({ serial_no: '0', letter_no: '', letter_date: '', fuel_id: 0, amount: '', remark: '', receiver: { id: 0, title: '' } });

export default function AmountReceiversFuelOil({ user, onBack }) {
  const fb = useFormButtons('FRMAMOUNTRECEIVERSFUELOIL', BUTTONS);
  const [cols, setCols] = useState([]);
  const [search, setSearch] = useState('');
  const [sel, setSel] = useState(null);
  const [modal, setModal] = useState(null);
  const [form, setForm] = useState(blank());
  const [err, setErr] = useState('');
  const [msg, setMsg] = useState('');

  const L = usePagedList((page, o) => API(`/receivers-fuel/?${qs({ page, search: o.search })}`)
    .then(j => { if (j.ok && page === 1) setCols(j.columns || []); return j; }));
  const reload = (s = search) => L.reload({ search: s });
  useEffect(() => { if (fb.open) reload(); }, [fb.open]);

  const F = (k, v) => setForm(f => ({ ...f, [k]: v }));
  const save = async () => {
    setErr('');
    const body = JSON.stringify({ ...form, receiver_id: form.receiver.id });
    const j = modal === 'new'
      ? await API('/receivers-fuel/create/', { method: 'POST', body })
      : await API(`/receivers-fuel/${sel.AmountReceiversFuelOilId}/update/`, { method: 'PUT', body });
    if (!j.ok) { setErr(j.msg); return; }
    setModal(null); reload();
  };
  const doDelete = async () => {
    setModal(null);
    const j = await API(`/receivers-fuel/${sel.AmountReceiversFuelOilId}/delete/`, { method: 'DELETE' });
    if (!j.ok) setMsg(j.msg); else { setSel(null); reload(); }
  };
  const has = !!sel;

  const toolbar = fb.open ? (
    <>
      <div style={ui.toolBtns}>
        {fb.can('BTNNEW') && <button onClick={() => { setForm(blank()); setErr(''); setModal('new'); }} style={ui.btnNew}>＋ جدید</button>}
        {fb.can('BTNEDIT') && <button disabled={!has} onClick={() => {
          setForm({ serial_no: sel['شماره سریال'] ?? '', letter_no: sel['شماره'] ?? '', letter_date: sel['تاریخ'] || '', fuel_id: sel.FuelId || 0,
            amount: sel['مقدار'] ?? '', remark: sel['شرح'] || '', receiver: { id: sel.AmountReceiverId || 0, title: sel['فروشنده'] || '' } });
          setErr(''); setModal('edit');
        }} style={{ ...ui.btnEdit, opacity: has ? 1 : 0.4 }}>✎ ویرایش</button>}
        {fb.can('BTNDELETE') && <button disabled={!has} onClick={() => setModal('delete')} style={{ ...ui.btnDel, opacity: has ? 1 : 0.4 }}>✕ حذف</button>}
      </div>
      <input value={search} onChange={e => setSearch(e.target.value)} onKeyDown={e => e.key === 'Enter' && reload()} placeholder="جستجو" style={{ ...ui.searchInput, minWidth: '180px' }} />
      <CountBadge shown={L.data.length} total={L.pager.total} loading={L.loading} unit="ردیف" />
      <ExcelButton title="سقف سوخت/روغن فروشندگان" columns={excelCols(cols, L.data)} rows={L.data} />
    </>
  ) : null;

  return (
    <>
      <ListPage user={user} onBack={onBack} title="سقف سوخت/روغن فروشندگان" subtitle="تدارکات — سامانه ارجان"
        toolbar={toolbar} error={L.error} pager={L.pager} onMore={L.more} loading={L.loading}>
        <Grid columns={cols} rows={L.data} rowKey="AmountReceiversFuelOilId" selectedKey={sel?.AmountReceiversFuelOilId} onSelect={setSel} />
      </ListPage>
      {(modal === 'new' || modal === 'edit') && (
        <Modal title={modal === 'new' ? '＋ سقف جدید' : '✎ ویرایش سقف'} onClose={() => setModal(null)} width="700px"
          footer={<>
            <button onClick={() => setModal(null)} style={ui.btnCancel}>لغو</button>
            {fb.can('BTNOK') && fb.can(modal === 'new' ? 'BTNNEW' : 'BTNEDIT') && <button onClick={save} style={ui.btnSave}>ثبت</button>}
          </>}>
          {err && <div style={ui.errBox}>⚠️ {err}</div>}
          <div style={ui.row}>
            <Field label="سریال"><TextIn num value={form.serial_no} onChange={v => F('serial_no', v)} /></Field>
            <Field label="شماره"><TextIn num value={form.letter_no} onChange={v => F('letter_no', v)} /></Field>
            <Field label="تاریخ"><DateIn value={form.letter_date} onChange={v => F('letter_date', v)} /></Field>
          </div>
          <div style={ui.row}>
            <Field label="فروشنده"><Lookup path="/receivers-fuel/lookup/receiver/" value={form.receiver} onChange={v => F('receiver', v)} /></Field>
            <Field label="نوع سوخت/روغن">
              <select value={form.fuel_id} onChange={e => F('fuel_id', Number(e.target.value))} style={ui.input}>
                {FUELS.map((f, i) => <option key={i} value={i}>{f}</option>)}
              </select>
            </Field>
            <Field label="مقدار"><TextIn num value={form.amount} onChange={v => F('amount', v)} /></Field>
          </div>
          <div style={ui.row}>
            <Field label="شرح"><TextIn value={form.remark} onChange={v => F('remark', v)} /></Field>
          </div>
        </Modal>
      )}
      {modal === 'delete' && <DeleteDialog onConfirm={doDelete} onCancel={() => setModal(null)} />}
      {msg && <MsgDialog text={msg} onClose={() => setMsg('')} />}
    </>
  );
}
